var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"modelLineChart-container",attrs:{"body-style":{ padding: '0px' }}},[_c('div',{staticClass:"modelLineChart-main"},[_c('div',{staticClass:"modelLineChart-main-header"},[_c('p',[_vm._v(_vm._s(_vm.chartData.title))])]),_c('div',{ref:"modelLineChart",staticStyle:{"width":"100%","height":"500px"}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }